// For a given category, filter out options that do not apply to this product
// category. If no category is selected then all options are valid.
export const filterInvalidOptionsForCategory = (category, options) =>
  options.filter(c => {
    const appliesToAllProducts =
      c.appliesToProduct && c.appliesToProductCategory.length === 0
    const appliesToThisCategory =
      c.appliesToProduct && c.appliesToProductCategory.includes(category)
    return (
      !category ||
      c.appliesToSupplier ||
      appliesToAllProducts ||
      appliesToThisCategory
    )
  })
